export default function useBaseUrl () {
  return window.__MQ_WIDGET_ORIGIN || window.location.origin
}
